<template>
  <div style="width: 100%; height: 100%;">
    <srline-chart v-if="seriesType === 'LineSeries'" v-bind="$props" @hit="onHit" :mouse-cursor-style="cursorStyle"/>
    <stack-column-chart v-if="seriesType === 'ColumnSeries'" v-bind="$props" @hit="onHit" :mouse-cursor-style="cursorStyle"/>
  </div>
</template>
<script>
import SrlineChart from './SrlineChart'
import StackColumnChart from './StackColumnChart'
import {MouseCursorStyle} from "@amcharts/amcharts4/core";

export default {
  name: 'am-xy-chart2',
  components: { StackColumnChart, SrlineChart },
  props: {
    seriesType: {
      type: String,
      default: 'ColumnSeries'
    },
    chartData: {
      type: Array,
      default: () => []
    },
    filter: {
      type: Array,
      default: () => []
    },
    refName: {
      type: String,
      required: true
    },
    stacked: {
      type: Boolean,
      default: false
    },
    numberFormatter: {
      type: Object,
      default : () => {
        return {
          numberFormat:"#a",
          bigNumberPrefixes: [
            { "number": 1e+3, "suffix": "천" },
            { "number": 1e+4, "suffix": "만" },
            { "number": 1e+8, "suffix": "억" }
          ]
        }
      }
    },
    numberPrefix: {
      type: String, 
      default: "₩"
    },
    useMinGridDistance: {
      type: Boolean,
      default: true
    },
    mouseCursorStyle: {
      type: String,
      default: 'default'
    },
    useCursorToolTip: {
      type: Boolean,
      default: false
    },
    showColumnTotal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    cursorStyle () {
      return MouseCursorStyle[this.mouseCursorStyle] ? MouseCursorStyle[this.mouseCursorStyle] : MouseCursorStyle.pointer
    }
  },
  methods: {
    onHit (ev) {
      this.$emit('hit', ev)
    }
  }
}
</script>
<style>
  
</style>



// WEBPACK FOOTER //
// src/pages/components/AmXyChart2.vue